import React from "react";
import SuccessPage from "../comp/SuccessPage";

export default function Success() {
  return <SuccessPage />;
}
